/* My changes start here 1 */

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".collage__item");

  function checkForVisibility() {
    items.forEach(function (item) {
      const itemRect = item.getBoundingClientRect();
      if (itemRect.top < window.innerHeight && itemRect.bottom >= 0) {
        item.classList.add("animate");
      }
    });
  }

  checkForVisibility();

  window.addEventListener("scroll", checkForVisibility);
});

/* My changes end here 1 */